import React from 'react';
import { Redirect } from 'react-router';

export const VendorRedirectGuard: React.FC<{
  redirect: boolean;
  to: string;
  push?: boolean;
  children?: React.ReactNode;
}> = ({ redirect, to, push, children }) => {
  if (redirect) return <Redirect to={to} push={push} />;
  return <>{children}</>;
};
